module.exports = "<ng-container *ngIf=\"auth.user$ | async as user\">\n    <app-admin-dashboard\n        *ngIf=\"user.hasRole('admin')\"\n    ></app-admin-dashboard>\n\n    <app-account-dashboard\n        *ngIf=\"user.hasRole('customer')\"\n    ></app-account-dashboard>\n\n    <app-security-guard-dashboard\n        *ngIf=\"user.hasRole('security-guard')\"\n    ></app-security-guard-dashboard>\n</ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./apps/eyewatch/src/app/eyewatch/dashboards/pages/dashboard/dashboard.component.html
// module id = ./apps/eyewatch/src/app/eyewatch/dashboards/pages/dashboard/dashboard.component.html
// module chunks = main